import { LitElement, html, nothing } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { translateFn } from '../../../../utils/translator.helper';
import { isEmpty } from 'lodash';
import { FontWeights } from '../../../../types/common/types';
import { GzLandingPageCompanyType } from '../../../../landingPage/types';
import { getLandingPageReference } from '../../../../landingPage/utils';
import { WelcomeImage } from '../utils/WelcomeImage';

/**
 * @summary Type here the description of this component
 * @tag gz-landing-page-welcome
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-landing-page-welcome')
export class WelcomeWebComponent extends LitElement {
  @property({ type: Number })
  companyType: GzLandingPageCompanyType;

  @property({ type: String, reflect: true })
  productVersion = '';

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="welcome-banner d-flex flex-row">
        <div class="text-container">
          <div class="title-container d-flex flex-column mb-4">
            <gz-title id="welcome-title" fontWeight=${FontWeights.MEDIUM} fontSize="22"
              >${translateFn('Welcome to')}</gz-title
            >
            <div class="large-title d-flex flex-row">
              <gz-title id="welcome-title-gz-version" class="fs-48" fontWeight=${FontWeights.BOLD}
                >${translateFn('GravityZone')}
                ${isEmpty(this.productVersion) ? nothing : 'V' + this.productVersion}</gz-title
              >
            </div>
          </div>
          <div class="data-container">
            <gz-text id="welcome-whats-new-description" class="fs-14 mb-3">
              ${translateFn(
                'Stay up to date with our release notes, your comprehensive guide to the latest features and updates!'
              )}
            </gz-text>
            <gz-button
              id="welcome-whats-new-button"
              class="whats-new mb-4"
              type="outline"
              color="secondary"
              theme="dark"
              buttonHeight="medium"
              buttonFontSize="medium"
              @click="${() => this.showWhatsNewPanel()}"
              >${translateFn("What's new")}</gz-button
            >
            <gz-text id="welcome-release-notes-description" class="fs-14 mb-3">
              ${translateFn('GravityZone is constantly improving. Stay informed with the most recent updates!')}
            </gz-text>
            <gz-button
              id="welcome-release-notes-button"
              class="release-notes mb-4"
              type="outline"
              color="secondary"
              theme="dark"
              buttonHeight="medium"
              buttonFontSize="medium"
              @click="${() => this.releaseNotesBtnAction()}"
              >${translateFn('Release notes')}</gz-button
            >
          </div>
        </div>
        <div class="image-container">${WelcomeImage.getWelcomeSvg()}</div>
      </div>
    `;
  }

  private releaseNotesBtnAction(): void {
    let releaseNotesLink =
      'https://www.bitdefender.com/business/support/en/77209-78199-gravityzone-control-center.html';
    if (this.companyType === GzLandingPageCompanyType.MSP) {
      releaseNotesLink = 'https://www.bitdefender.com/business/support/en/77211-78199-gravityzone-control-center.html';
    }

    releaseNotesLink = releaseNotesLink + `?icid=button|b|${getLandingPageReference(this.companyType)}|release-notes`;

    window.open(releaseNotesLink, '_blank');
  }

  private showWhatsNewPanel(): void {
    try {
      analytics.trackPageInteraction({
        reference: `${getLandingPageReference(this.companyType)}`,
        asset: 'show-whats-new',
      });
    } finally {
      this.dispatchEvent(
        new Event('show-whats-new', {
          bubbles: true,
          composed: true,
        })
      );
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-landing-page-welcome': WelcomeWebComponent;
  }
}
